import { render, staticRenderFns } from "./withholdGold.vue?vue&type=template&id=5e070d5a&scoped=true"
import script from "./withholdGold.vue?vue&type=script&lang=js"
export * from "./withholdGold.vue?vue&type=script&lang=js"
import style0 from "./withholdGold.vue?vue&type=style&index=0&id=5e070d5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_29ccf6a1548590c1291b44f0faebdb79/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e070d5a",
  null
  
)

export default component.exports